<template>
  <span :id="model?.system?.id">
    <SmartLinkItemComponent :id="model?.system?.id" :component="!model?.system?.workflow">
      <div class="split-content-block container">
        <SmartLinkStandaloneElement :codename="type.elements.title.codename">
          <h1
            v-if="model?.elements.title.value && model?.elements.title.value.length > 0"
            class="mb-4"
          >
            {{ model?.elements.title.value }}
          </h1>
        </SmartLinkStandaloneElement>
        <div class="row">
          <div
            :class="`block-richtext ${contentGrid.left} ${contentGridOrder.left} row__item ${splitMobileNoMargin}`"
          >
            <SmartLinkStandaloneElement :codename="type.elements.left_content.codename">
              <RichText :value="model?.elements.leftContent.value" />
            </SmartLinkStandaloneElement>
          </div>
          <div :class="`block-richtext ${contentGrid.right} ${contentGridOrder.right}`">
            <SmartLinkStandaloneElement :codename="type.elements.right_content.codename">
              <RichText :value="model?.elements.rightContent.value" />
            </SmartLinkStandaloneElement>
          </div>
        </div>
      </div>
    </SmartLinkItemComponent>
  </span>
</template>
<script lang="ts" setup>
import { contentTypes, type SplitContentBlockModel } from '~/models'

const type = contentTypes.split_content_block
const props = defineProps<{ model: SplitContentBlockModel }>()

type SplitContentBlockClass = { left: string; right: string }
const contentGrid: Ref<SplitContentBlockClass> = computed(() => {
  const style = props.model?.elements.blockStyling
  if (style.value.length > 0) {
    switch (style.value[0].codename) {
      case 'n60_40':
        return { left: 'col-lg-7', right: 'col-lg-5' }
      case 'n40_60':
        return { left: 'col-lg-5', right: 'col-lg-7' }
      case 'n50_50':
        return { left: 'col-lg-6', right: 'col-lg-6' }
      case 'n70_30':
        return { left: 'col-lg-8', right: 'col-lg-4' }
      case 'n30_70':
        return { left: 'col-lg-4', right: 'col-lg-8' }
    }
  }
  return { left: 'col-lg-6', right: 'col-lg-6' }
})

const contentGridOrder: Ref<SplitContentBlockClass> = computed(() => {
  const mobileStyling = props.model?.elements.mobileStyling
  if (mobileStyling.value.length > 0) {
    switch (mobileStyling.value[0].codename) {
      case 'left_content_on_top':
        return { left: 'order-1 order-lg-1', right: 'order-2 order-lg-2' }
      case 'right_content_on_top':
        return { left: 'order-2 order-lg-1', right: 'order-1 order-lg-2' }
    }
  }
  return { left: 'order-1 order-lg-1', right: 'order-2 order-lg-2' }
})

const splitMobileNoMargin = ref('')
const removeSplitMobileMargin = () => {
  splitMobileNoMargin.value = 'mb-0'
}
provide('removeSplitMobileMargin', removeSplitMobileMargin)
</script>
